import api from './api';

/** Klachtenreglement platform (migratie 183). */
export type KlachtGebruikerType = 'CORPORATE_CLIENT' | 'PROFESSIONAL' | 'TRAINING_PROVIDER' | 'EMPLOYEE_CONSUMER';
export const KLACHT_GEBRUIKER_TYPES: KlachtGebruikerType[] = ['CORPORATE_CLIENT', 'PROFESSIONAL', 'TRAINING_PROVIDER', 'EMPLOYEE_CONSUMER'];

export type KlachtCategorie =
  | 'TECHNICAL'
  | 'FINANCIAL_BILLING'
  | 'DATA_PROTECTION'
  | 'ACADEMY_ACCREDITATION'
  | 'ACADEMY_POP_TRANSACTION'
  | 'POOL_SLA'
  | 'OTHER';
export const KLACHT_CATEGORIEEN: KlachtCategorie[] = [
  'TECHNICAL',
  'FINANCIAL_BILLING',
  'DATA_PROTECTION',
  'ACADEMY_ACCREDITATION',
  'ACADEMY_POP_TRANSACTION',
  'POOL_SLA',
  'OTHER',
];

export type KlachtStatus = 'ontvangen' | 'in_behandeling' | 'afgehandeld';

export interface KlachtBoekingOptie {
  id: string;
  titel: string;
  status: string;
  netto_bedrag: number;
  created_at: string;
}

export interface KlachtContext {
  gebruiker_type: KlachtGebruikerType;
  organisatie_naam: string | null;
  contact_naam: string;
  email: string;
  telefoon: string;
  reglement_versie: string;
  boekingen: KlachtBoekingOptie[];
}

export interface KlachtSamenvatting {
  id: string;
  ticket_nummer: string;
  gebruiker_type: KlachtGebruikerType;
  organisatie_naam: string | null;
  categorie: KlachtCategorie;
  referentie: string;
  status: KlachtStatus;
  uiterste_reactiedatum: string;
  afgehandeld_op: string | null;
  created_at: string;
  uitspraak?: string | null;
}

export interface KlachtDetail extends KlachtSamenvatting {
  contact_naam: string;
  email: string;
  telefoon: string;
  omschrijving: string;
  gewenste_oplossing: string;
  academy_boeking_id: string | null;
  stripe_referentie: string | null;
  bijlage_naam: string | null;
  reglement_versie: string;
  akkoord_op: string;
  interne_notitie: string | null;
  boeking_titel: string | null;
  boeking_status: string | null;
  boeking_bedrag: string | null;
  boeking_wallet_deel: string | null;
}

const d = <T>(r: { data: { data: T } }) => r.data.data;

export const getKlachtContext = () => api.get<{ data: KlachtContext }>('/klachten/context').then(d);
export const getMijnKlachten = () => api.get<{ data: KlachtSamenvatting[] }>('/klachten/mijn').then(d);
export const dienKlachtIn = (form: FormData) =>
  api.post<{ data: { id: string; ticket_nummer: string; uiterste_reactiedatum: string } }>('/klachten', form).then(d);

export const getAdminKlachten = (status?: KlachtStatus) =>
  api.get<{ data: KlachtSamenvatting[] }>('/admin/klachten', { params: status ? { status } : {} }).then(d);
export const getAdminKlacht = (id: string) => api.get<{ data: KlachtDetail }>(`/admin/klachten/${id}`).then(d);
export const werkAdminKlachtBij = (id: string, invoer: { status?: 'ontvangen' | 'in_behandeling'; interne_notitie?: string }) =>
  api.patch<{ data: KlachtDetail }>(`/admin/klachten/${id}`, invoer).then(d);
export const handelAdminKlachtAf = (id: string, uitspraak: string) =>
  api.post<{ data: KlachtDetail }>(`/admin/klachten/${id}/uitspraak`, { uitspraak }).then(d);
export const downloadKlachtBijlage = async (id: string, naam: string) => {
  const r = await api.get(`/admin/klachten/${id}/bijlage`, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = naam;
  a.click();
  URL.revokeObjectURL(url);
};
